import { api, appCommons } from '@/app/shared/services';

import { apiConstants } from '../../config';

const fetchGuide = (payload) => {
  const url = apiConstants.fetchGuide;

  // return api.post(url, payload);
  return api.get(url);
};

const fetchTags = (payload) => {
  const url = apiConstants.fetchTags;

  // return api.post(url, payload);
  return api.get(url);
};

const fetchArtefacts = (payload) => {
  const url = apiConstants.fetchArtefacts;

  // return api.post(url, payload);
  return api.get(url);
};

const fetchArtefact = (payload) => {

  let scopeList = [];
  let tagList = [];
  let refList = [];
  let endpoint = apiConstants[payload.type.toLowerCase()];

  if(payload.tags) {
    for(var tag of payload.tags) {
      if(tag.type === 'S') {
        scopeList.push(tag.code);
      }
      if(tag.type === 'B') {
        tagList.push(tag.tag);
      }
      if(tag.type === 'C') {
        refList.push(tag.tag);
      }
    }

    if(scopeList.length === 0) {
      scopeList = appCommons.currentScope();
    }
  }

  let params = {
    "client": "gex",
    "from_date": payload.dateRange ? payload.dateRange.startDate : new Date(),
    "to_date": payload.dateRange ? payload.dateRange.endDate : new Date(),
    "metric" : payload.mode ? payload.mode : "revenue",
    "req_type": (payload.type.toLowerCase() === "bdl" || payload.type.toLowerCase() === "cdl") ?
                  (payload.type.indexOf('B') !== -1 ? "brand" : "product_category") : payload.type.toLowerCase(),
    "product_category_list": refList,
    "brand_list": tagList,
    "store_code_list": scopeList
  }

//  return api.get(endpoint);
  return api.post(endpoint, params);
};

/*
const fetchArtefact = (payload) => {
  const url = apiConstants.fetchArtefact;

  let scopeList = [];
  let tagList = [];
  let refList = [];
  let endpoint = 'cli'+payload.type.toLowerCase();

  if(payload.tags) {
    for(var tag of payload.tags) {
      if(tag.type === 'S') {
        scopeList.push(tag.code);
      }
      if(tag.type === 'B') {
        tagList.push(tag.tag);
      }
      if(tag.type === 'C') {
        refList.push(tag.tag);
      }
    }

    if(scopeList.length === 0) {
      scopeList = appCommons.currentScope();
    }
  }

  let params = {
    "client": "gex",
    "from_date": payload.dateRange ? payload.dateRange.startDate : new Date(),
    "to_date": payload.dateRange ? payload.dateRange.endDate : new Date(),
    "metric" : payload.mode ? payload.mode : "revenue",
    "product_category_list": refList,
    "brand_list": tagList,
    "store_code_list": scopeList
  }

  return api.post(endpoint, params);
};
*/

const fetchArtefactUnit = (payload) => {
  const url = apiConstants.fetchArtefactUnit;

  let scopeList = [];
  let tagList = [];
  let endpoint = apiConstants['phi'];

  if(payload.tags) {
    for(var tag of payload.tags) {
      if(payload.type.toLowerCase() === 'bdi' || payload.type.toLowerCase() === 'bfdi') {
        tagList.push(tag.sku_id);
      }
      if(payload.type.toLowerCase() === 'cdi') {
        tagList.push(tag.desc);
      }
    }

    if(scopeList.length === 0) {
      scopeList = appCommons.currentScope();
    }
  }

  let params = {
    "client": "gex",
    "from_date": payload.dateRange ? payload.dateRange.startDate : new Date(),
    "to_date": payload.dateRange ? payload.dateRange.endDate : new Date(),
    "metric" : payload.mode ? payload.mode : "revenue",
    "perf_type": payload.type.toLowerCase(),
    "perf_on": tagList,
    "store_code_list": scopeList
  }

//  return api.get(endpoint);
  return api.post(endpoint, params);
};

const fetchMock = (payload) => {

  let endpoint = apiConstants[payload.type.toLowerCase()+'_mock'];
  
  if(!endpoint) {
    endpoint = 'mock-data/mock.json'
  }
  return api.get(endpoint);
};

export { fetchGuide, fetchTags, fetchArtefacts, fetchArtefact, fetchArtefactUnit, fetchMock };
